import React from "react";
import styled, { css } from "styled-components";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { useIsMobile } from "@utils/hooks";
import { fadeIn } from "@ui/styles/keyframes";
import { alpha } from "@ui/styles/utils";
import { KebabIcon } from "@ui/components/icons";
import { row } from "@ui/components/layout";
import { Menu, MenuProps } from "./menu";

interface KebabMenuProps extends Omit<MenuProps, "renderMenuContent"> {
	Icon?: React.ReactElement;
	blur?: boolean;
	isVisible?: boolean;
	authOnly?: boolean;
}

export const KebabMenu: React.FC<KebabMenuProps> = ({ Icon, isVisible = true, children, authOnly, ...props }) => {
	const isMobile = useIsMobile();
	const currentProfile = useCurrentProfile();

	if (!currentProfile && authOnly) {
		return null;
	}
	return (
		<BlurredMenu {...props} isVisible={isVisible} renderMenuContent={() => children} bottomSheetMode={isMobile}>
			{Icon ?? <BigKebab />}
			{/* Utilisez l'état pour conditionnellement rendre le lien */}
			{/* {showMessageLink && <Link to={Path.Chatmessage(currentProfile.id)}>Voir ma messagerie</Link>} */}
		</BlurredMenu>
	);
};

const BlurredMenu = styled(Menu).withConfig({
	shouldForwardProp: (prop) => !["blur", "isVisible"].includes(prop),
})<{ blur?: boolean; isVisible: boolean }>`
	${row(0, "center", "center")};
	opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
	animation: ${fadeIn} 0.1s linear;
	border-radius: 16px;
	width: 32px;
	height: 32px;
	${({ blur }) =>
		blur &&
		css`
			background-color: ${({ theme }) => alpha(theme.colors.white, 1)};
		`}
`;

const BigKebab = styled(KebabIcon)`
	width: 24px;
	height: 24px;
`;
